import { render, staticRenderFns } from "./DepenglishForm.vue?vue&type=template&id=4a3fcebc&scoped=true&"
import script from "./DepenglishForm.vue?vue&type=script&lang=js&"
export * from "./DepenglishForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3fcebc",
  null
  
)

export default component.exports